import React from 'react';
import './CompanyStats.css';

const stats = [
  {
    id: 'hours',
    value: '150K+',
    label: 'Development hours',
    note: 'Engineering time shipped across web and mobile products',
    icon: 'clock',
  },
  {
    id: 'projects',
    value: '30+',
    label: 'Projects delivered',
    note: 'Live platforms, apps, and growth programs for operating teams',
    icon: 'projects',
  },
  {
    id: 'years',
    value: '10+',
    label: 'Years of experience',
    note: 'Delivery across .NET, PHP, iOS, Android, and digital growth',
    icon: 'experience',
  },
  {
    id: 'offices',
    value: '2',
    label: 'Delivery locations',
    note: 'Studios that collaborate with clients across time zones',
    icon: 'map',
  },
];

const Icon = ({ name }) => {
  if (name === 'clock') {
    return (
      <svg viewBox="0 0 48 48" aria-hidden="true">
        <circle cx="24" cy="24" r="18" fill="#eef8f6" />
        <circle cx="24" cy="24" r="14" fill="none" stroke="#0f766e" strokeWidth="2.4" />
        <path d="M24 16v9l7 4" fill="none" stroke="#0b1520" strokeWidth="2.4" strokeLinecap="round" strokeLinejoin="round" />
      </svg>
    );
  }
  if (name === 'projects') {
    return (
      <svg viewBox="0 0 48 48" aria-hidden="true">
        <rect x="8" y="12" width="32" height="24" rx="4" fill="#eef8f6" />
        <rect x="12" y="16" width="12" height="6" rx="1.5" fill="#0f766e" />
        <rect x="12" y="26" width="24" height="2.5" rx="1.2" fill="#99f6e4" />
        <rect x="12" y="31" width="18" height="2.5" rx="1.2" fill="#5eead4" />
      </svg>
    );
  }
  if (name === 'experience') {
    return (
      <svg viewBox="0 0 48 48" aria-hidden="true">
        <circle cx="24" cy="24" r="18" fill="#eef8f6" />
        <circle cx="24" cy="24" r="13" fill="none" stroke="#0f766e" strokeWidth="2.2" />
        <ellipse cx="24" cy="24" rx="6.5" ry="13" fill="none" stroke="#14b8a6" strokeWidth="1.8" />
        <path d="M11 24h26M15 17h18M15 31h18" stroke="#0b1520" strokeWidth="1.4" />
      </svg>
    );
  }
  return (
    <svg viewBox="0 0 48 48" aria-hidden="true">
      <circle cx="24" cy="24" r="18" fill="#eef8f6" />
      <path d="M24 12c5.2 0 9.5 6.2 9.5 14S29.2 40 24 40s-9.5-6.2-9.5-14S18.8 12 24 12z" fill="none" stroke="#0f766e" strokeWidth="2.2" />
      <circle cx="24" cy="23" r="4.2" fill="#14b8a6" />
      <path d="M24 27v8" stroke="#0b1520" strokeWidth="2" strokeLinecap="round" />
    </svg>
  );
};

const CompanyStats = () => (
  <section className="stats-section section">
    <div className="container">
      <p className="eyebrow" style={{ display: 'block', textAlign: 'center' }}>By the numbers</p>
      <h2 className="section-title">A delivery studio with measurable output</h2>
      <p className="section-subtitle">
        Hours shipped, products launched, and the experience behind them.
      </p>
      <div className="stats-grid">
        {stats.map((stat) => (
          <article key={stat.id} className={`stat-card stat-${stat.id}`}>
            <div className="stat-icon">
              <Icon name={stat.icon} />
            </div>
            <div className="stat-value">{stat.value}</div>
            <div className="stat-label">{stat.label}</div>
            <p className="stat-note">{stat.note}</p>
          </article>
        ))}
      </div>
    </div>
  </section>
);

export default CompanyStats;
